import React, { useEffect, useRef } from 'react'

import {
  useDocument,
  useIsCameraMoving,
  useIsCameraZooming,
  usePan,
  useZoom,
} from '@sketch-hq/sketch-web-renderer'

import { useDevToolsSetting } from '@sketch/devtools'
import { Wrapper, OriginCross } from './PageOriginContent.styles'
import { useAnnotationOverlayOrigin } from 'modules/annotations/hooks'

const PageOriginContent: React.FC = ({ children }) => {
  const ref = useRef(null)

  const pan = usePan() || { x: 0, y: 0 }
  const zoom = useZoom() || 1
  const isCameraMoving = useIsCameraMoving()
  const isCameraZooming = useIsCameraZooming()

  const [showPageOrigin] = useDevToolsSetting('webRenderer.showPageOrigin')

  const [
    annotationOverlayOrigin /* eslint-disable-line @typescript-eslint/no-unused-vars */,
    setAnnotationOverlayOrigin,
  ] = useAnnotationOverlayOrigin()

  useEffect(() => {
    setAnnotationOverlayOrigin(ref, zoom)
  }, [setAnnotationOverlayOrigin, zoom])

  const document = useDocument()
  if (!document) return null

  const style = {
    // willChange hints the browser that we are going to update these properties
    willChange: isCameraMoving ? 'contents' : undefined,
    // Disabling the pointer-events when the camera is moving, so the user can pan/scroll freely
    pointerEvents: isCameraMoving ? 'none' : 'auto',
    transform: `translate3d(${Math.round(pan.x * zoom)}px, ${Math.round(
      pan.y * zoom
    )}px, 0)`,
    width: `${document.bounds.width * zoom}px`,
    height: `${document.bounds.height * zoom}px`,
    marginTop: `${-document.bounds.y * zoom}px`,
    marginLeft: `${-document.bounds.x * zoom}px`,
  } as const

  return (
    <Wrapper ref={ref} style={style} data-canvas-zooming={isCameraZooming}>
      {children}
      {showPageOrigin && <OriginCross />}
    </Wrapper>
  )
}

export default PageOriginContent
